import React, { Component } from 'react'

export default class Error_page extends Component {
    render() {
        return (
            <div>Error_page_404</div>
        )
    }
}
